import React, { useState } from 'react';
import styles from './faq_section.module.scss';

const FAQSection: React.FC = () => {
  const [collapsedQuestion, setCollapsedQuestion] = useState<string>('');

  return (
    <div id='faqs' className={`container py-5 ${styles.limitedWidthForContainer}`}>
      <div className='row'>
        <div className='col'>
          <h2 className='mb-45 py-1 border-bottom'>FAQ</h2>
          <div className='cards-group' id='accordion'>
            <div className='card my-3 border-0'>
              <div
                className={`${styles.cardTitleBackground} card-header border-0`}
                id='faqHeadingOne'
              >
                <div className='card-title mb-0'>
                  <a
                    className='btn btn-link link-gray-orange w-100 collapsed text-start py-2'
                    data-bs-toggle='collapse'
                    data-bs-target='#faq1'
                    onClick={() => setCollapsedQuestion(collapsedQuestion === 'faq1' ? '' : 'faq1')}
                  >
                    <div className='d-flex justify-content-between'>
                      <span className='me-3'>
                        I have a paid membership, why am I not able to register?
                      </span>
                      <div className='align-self-center'>
                        <i
                          className={`fal icon-angle-${
                            collapsedQuestion === 'faq1' ? 'up' : 'down'
                          } float-end`}
                        />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div className='collapse' id='faq1' data-bs-parent='#accordion'>
                <div className='card-body'>
                  <p>
                    If you have a paid membership, double check you are using the Devex email
                    address tied to your paid membership when registering for the webinar.
                  </p>
                  <p>
                    Your membership may not give you access to the particular event you wish to
                    attend. For example, if you have a Career Account and are trying to access a
                    Devex Funding webinar.
                  </p>
                  <p>
                    If you need to check what membership you have, click{' '}
                    <a
                      // eslint-disable-next-line max-len
                      href='https://support.devex.com/hc/en-us/articles/360002085813-How-can-I-check-what-membership-I-have-'
                      target='_blank'
                      className='cta-link'
                      rel='noreferrer'
                    >
                      here
                    </a>{' '}
                    for a step-by-step guide.
                  </p>
                </div>
              </div>
            </div>

            <div className='card my-3 border-0'>
              <div
                className={`${styles.cardTitleBackground} card-header border-0`}
                id='faqHeadingTwo'
              >
                <div className='card-title mb-0'>
                  <a
                    className='btn btn-link link-gray-orange w-100 collapsed text-start py-2'
                    data-bs-toggle='collapse'
                    data-bs-target='#faq2'
                    onClick={() => setCollapsedQuestion(collapsedQuestion === 'faq2' ? '' : 'faq2')}
                  >
                    <div className='d-flex justify-content-between'>
                      <span className='me-3'>
                        I have registered for the livestream of the event, why haven’t I received
                        the link to join?
                      </span>
                      <div className='align-self-center'>
                        <i
                          className={`fal icon-angle-${
                            collapsedQuestion === 'faq1' ? 'up' : 'down'
                          } float-end`}
                        />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div className='collapse' id='faq2' data-bs-parent='#accordion'>
                <div className='card-body'>
                  <p>
                    Members who have successfully registered for an event will normally receive two
                    separate emails:
                  </p>
                  <ol>
                    <li>
                      An email confirming your registration to the event, sent after you&apos;ve
                      registered to the event
                    </li>
                    <li>An email with the link to join the event on the day of the event</li>
                  </ol>
                  <br />
                  <p>
                    Please note that clicking on the <strong>Join</strong> link in the email before
                    the livestream of the event has started will take you to a meeting lobby page on
                    Zoom where you can see an active countdown clock for the event&apos;s date and
                    time.
                  </p>
                  <p>
                    If you have not received any of the above emails, please email us at{' '}
                    <a href='mailto:webinars@devex.com' className='cta-link'>
                      webinars@devex.com
                    </a>{' '}
                    with the email address used for registration and we&apos;d be happy to help.
                  </p>
                </div>
              </div>
            </div>

            <div className='card my-3 border-0'>
              <div
                className={`${styles.cardTitleBackground} card-header border-0`}
                id='faqHeadingThree'
              >
                <div className='card-title mb-0'>
                  <a
                    className='btn btn-link link-gray-orange w-100 collapsed text-start py-2'
                    data-bs-toggle='collapse'
                    data-bs-target='#faq3'
                    onClick={() => setCollapsedQuestion(collapsedQuestion === 'faq3' ? '' : 'faq3')}
                  >
                    <div className='d-flex justify-content-between'>
                      <span className='me-3'>
                        Devex Pro, Devex Pro Funding, and Devex Pro Funding for teams — what&apos;s
                        the difference?
                      </span>
                      <div className='align-self-center'>
                        <i
                          className={`fal icon-angle-${
                            collapsedQuestion === 'faq1' ? 'up' : 'down'
                          } float-end`}
                        />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div className='collapse' id='faq3' data-bs-parent='#accordion'>
                <div className='card-body'>
                  <p>
                    <strong>Devex Pro</strong> is a paid news and analysis subscription available
                    for purchase online that provides deeper analysis and exclusive insights from
                    our reporters and analysts. Subscribers get daily must-read news, proprietary
                    analysis and reporting, a special Pro-only newsletter, exclusive digital events,
                    and access to thousands of previously published articles. Devex Pro is designed
                    to help professionals decipher development and make a bigger impact.
                  </p>
                  <p>
                    <strong>Devex Pro Funding</strong> is a news and funding platform membership
                    designed for individuals that can be purchased online. Members get access to
                    Devex Pro in addition to the Devex funding platform. The funding platform is a
                    searchable database of funding opportunities from 850+ sources, early
                    information, and news on funding, contract awards, and shortlist announcements.
                    Individuals use the platform features to improve their funding pipeline and
                    remain informed of the latest changes in development funding.
                  </p>
                  <p>
                    <strong>Devex Pro Funding for teams</strong> caters to the needs of groups,
                    teams, and entire organizations. It includes all that is offered with Devex Pro
                    Funding in addition to features that allow easy sharing of funding opportunities
                    and email alerts with those that don&apos;t have membership access. Members can
                    download search results to allow them to sort and integrate them into their
                    project management system. Pro Funding for teams offers access to the database
                    of 1 million+ development professionals so that members can source experts for
                    proposals, donor contacts, and other key contacts to support their funding
                    strategy. Members can connect with our team of analysts on particular questions
                    around funding opportunities. This is combined with training and support from
                    our member experience team to ensure members can maximize the benefits of the
                    membership.
                  </p>
                  <p>
                    <strong>
                      Here&apos;s a breakdown that outlines the differences in more detail:
                    </strong>
                  </p>
                  <p>
                    <strong>Devex Pro offers access to:</strong>
                  </p>
                  <ol>
                    <li>
                      Daily coverage, analysis, and reporting of global development issues of the
                      day from an insider&apos;s perspective — covering topics from food systems to
                      financial inclusion to fracases atop UN agencies and among development
                      leaders.
                    </li>
                    <li>
                      In-depth analysis of policy changes within the major funding institutions.
                    </li>
                    <li>
                      Reports and data visualizations of current funding streams offer context and
                      understanding of the distribution of donor funding.
                    </li>
                    <li>
                      A special, Pro-only weekend newsletter designed to give you a jump-start and a
                      comparative advantage for the week ahead.
                    </li>
                    <li>
                      Digital events where you can hear from and interact directly with Devex’s top
                      reporters, editors, and analysts - as well as industry insiders, policymakers,
                      and leaders we invite in.
                    </li>
                  </ol>
                  <br />
                  <p>
                    <strong>Devex Pro Funding offers access to:</strong>
                  </p>
                  <ol>
                    <li>Devex Pro content</li>
                    <li>
                      Active tenders, grants, and open opportunities from over 850 traditional and
                      non-traditional donor agencies.
                    </li>
                    <li>
                      Program reports to learn about the scope of the overall project, before the
                      tenders, grants, and open opportunities are released.
                    </li>
                    <li>
                      The funding activity database offers news of the latest new partnerships, loan
                      approvals, and funding instruments, which are compiled using machine learning
                      technology and analytical expertise to track 600k+ national and international
                      media and donor sources each day.
                    </li>
                    <li>
                      Organizations that have been shortlisted and won contracts are in the contract
                      awards database.
                    </li>
                    <li>
                      Custom alerts to receive all relevant funding opportunities and funding
                      activity feed entries directly to your inbox each day.
                    </li>
                  </ol>
                  <br />
                  <p>
                    <strong>Devex Pro Funding for teams offers access to:</strong>
                  </p>
                  <ol>
                    <li>
                      All of what&apos;s offered with Devex Pro Funding features and Devex Pro
                      content.
                    </li>
                    <li>
                      Sharing features to allow users to share funding opportunities, news, and
                      entire email alerts with others, whether they have full access to Devex or
                      not, improving the visibility of key information across your organization.
                    </li>
                    <li>
                      The database of 1 million+ development professionals. Searchable by location,
                      donor, and sector experience, the professional profiles listed in our database
                      are an essential resource for business development, proposal writing, and
                      partnerships teams.
                    </li>
                    <li>
                      Downloadable funding search results for use in internal systems. With
                      organizations using a variety of different internal project pipeline
                      management systems, integration between systems and information on Devex has
                      never been more important.
                    </li>
                    <li>Expert advice from our analysts 24/5 via the contact an analyst button.</li>
                    <li>
                      Tailored content so each user can receive the information they specifically
                      need to support their work and increase individual productivity.
                    </li>
                    <li>
                      Dedicated Support from our member experience team. Get technical help,
                      onboarding and training sessions, and answers to any questions you have.
                    </li>
                    <li>
                      One central page to manage users and multiple access points, and billing.
                    </li>
                  </ol>
                  <br />
                  <p>
                    To sign up visit our Pro Funding{' '}
                    <a href='' target='_blank' className='cta-link'>
                      https://pgs.devex.com/devex-pro-funding-orgs/
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>

            <div className='card my-3 border-0'>
              <div
                className={`${styles.cardTitleBackground} card-header border-0`}
                id='faqHeadingFour'
              >
                <div className='card-title mb-0'>
                  <a
                    className='btn btn-link link-gray-orange w-100 collapsed text-start py-2'
                    data-bs-toggle='collapse'
                    data-bs-target='#faq4'
                    onClick={() => setCollapsedQuestion(collapsedQuestion === 'faq4' ? '' : 'faq4')}
                  >
                    <div className='d-flex justify-content-between'>
                      <span className='me-3'>
                        Do you have a question or a problem registering for this event?
                      </span>
                      <div className='align-self-center'>
                        <i
                          className={`fal icon-angle-${
                            collapsedQuestion === 'faq1' ? 'up' : 'down'
                          } float-end`}
                        />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div className='collapse' id='faq4' data-bs-parent='#accordion'>
                <div className='card-body'>
                  <p>
                    Contact us if you have any question or need help. We will reply as fast as
                    possible:{' '}
                    <a href='mailto:webinars@devex.com' className='cta-link'>
                      webinars@devex.com
                    </a>{' '}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
